import api from './api';

const ENDPOINT = 'platform-regulations';

const RegulationService = {
  get: () => api.get(ENDPOINT),
};

export default RegulationService;
